
import AuthCallback from '@/components/AuthCallback';
import AuthToast from '@/components/AuthToast';
import DemoTemplate from '@/components/DemoTemplate';
import HomePage from '@/components/HomePage';
import PromptDemoGenerator from '@/components/PromptDemoGenerator';
import ProtectedRoute from '@/components/ProtectedRoute';
import TokenStatusIndicator from '@/components/TokenStatusIndicator';
import { useApiAuthFailureHandler } from '@/hooks/useApiAuthFailureHandler';
import { useAuthToast } from '@/hooks/useAuthToast';
import { Route, Routes } from 'react-router-dom';

function App() {
  // Handle API authentication failures globally
  useApiAuthFailureHandler();
  
  // Handle authentication toasts
  const { toasts, removeToast } = useAuthToast();

  return (
    <div className="App">
      {/* Show token status indicator only in development and only when there are issues */}
      {import.meta.env.DEV && <TokenStatusIndicator />}
      
      {/* Show authentication toasts */}
      {toasts.map((toast) => (
        <AuthToast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          duration={toast.duration}
          onClose={() => removeToast(toast.id)}
        />
      ))}
      
      <Routes>
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route 
          path="/" 
          element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/generate-demo" 
          element={
            <ProtectedRoute>
              <PromptDemoGenerator />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/demo/:demoId" 
          element={
            <ProtectedRoute>
              <DemoTemplate />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </div>
  );
}

export default App;